/* global connect React Component */
import mixinsFunc from "../mixins";
export class CreditRating extends Component {
  constructor(props) {
    super(props);
    this.creditInfo = {
      disabled: {
        "user_name": true,
        "user_id": true,
        "email_address": true,
        "age": true
      }
    }
    let mixins = mixinsFunc(this);
    props.initialconstruct.bind(this)("CreditRating");
    this.state = {
      infoData: {},
      links: mixins.links || [],
      fields: {
        creditInfo: mixins.creditInfo,
      },
    };
  }
  breadCumRight() {
    return <AppStepper index={5} count={5}></AppStepper>;
  }

  fetchFileList() {
    this.api.execApi("getPartnerDocument").then((response) => {
      let items = response.data.items;
      items.map((item) => {
        let doc_meta_name = item.doc_meta_name?.decode()?.parse()
        if (doc_meta_name) {
          let { name, group, documentKey } = doc_meta_name;
          app.store(`uploads.${group}.${documentKey}.${name}`, {
            isuploaded: true,
            "data-invalue": item['attachment_id'],
            "data-filename": item['file_name'],
            labelname: item['file_name'],
            password: item['password'],
            ...item
          });
        }

        //app.store(`${group}.uploads.${documentKey}.${name}`,payload);
      });
      console.log({ response });
    });
  }
  getClientRating() {
    this.fetchFileList();
    this.api.execApi('getClientRating').then((response) => {
      let data = response.data;
      console.log({ data });
      this.setState((state) => ({
        infoData: data
      }));
    });
  }

  submitRecord(e, data) {
    data = Object.filter(data, (v) => v);
    let parsedData = parseInput(data);
    console.log({ data, parsedData });
    if (this.state.infoData) {
      this.api.execApi('putClientRating', {
        "rating_agency": parsedData.rating_agency,
        "current_rating": parsedData.current_rating,
        "valid_till": parsedData.valid_till,
        "attachment_id": parsedData.credit_rating_file.attachment_id,
        "filename": parsedData.credit_rating_file.filename,
        // "password": parsedData.rating_agency,
        // "status": parsedData.rating_agency,
        // "remarks": parsedData.rating_agency
      }).then(() => {
        this.getClientRating();
        success("Info Updated Successfull").promise.then(() => {
          navigate("/app/my_profile");
        });
      });
    } else {
      this.api.execApi('postClientRating', {
        "rating_agency": parsedData.rating_agency,
        "current_rating": parsedData.current_rating,
        "valid_till": parsedData.valid_till,
        "attachment_id": parsedData.credit_rating_file.attachment_id,
        "filename": parsedData.credit_rating_file.filename,
        // "password": parsedData.rating_agency,
        // "status": parsedData.rating_agency,
        // "remarks": parsedData.rating_agency
      }).then(() => {
        this.getClientRating();
        success("Info Updated Successfull").promise.then(() => {
          navigate("/app/my_profile");
        });
      });
    }

  }

  componentDidMount() {
    this.getClientRating();
  }

  render() {
    let { breadCumRight } = this;
    let { links, fields, infoData } = this.state;
    /* eslint-disable-next-line react/jsx-no-undef */
    return (
      <AppWrapper
        customTitle="Update Profile"
        title="Profile"
        slots={{ breadCumRight }}
      >
        <AppLinkTabs data={links}></AppLinkTabs>
        <div className="card">
          <div className="card-body">
            <AppFormData
              fields={fields.creditInfo}
              size={3}
              fieldclass="col-4"
              submitText="Save"
              data={infoData}
              onSubmit={(...arg) => this.submitRecord(...arg)}

            />
          </div>
        </div>
      </AppWrapper>
    );
  }
}

export default connect(CreditRating);
